import React from 'react'
import DividerSection from '@/components/DividerSection'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

import s from './styles.module.scss'

const CardSelectedService = ({ name, price, description, duration, id, isExtra, moneySign, handleDeleteService }) => {
  return (
    <div className={s.cardContainer} key={id}>
      <div className={s.serviceHeader}>
        <span>
          <span className={s.serviceName}>{name?.toUpperCase()}</span>
          <b>
            {' '}
            {moneySign}
            {price}
          </b>
        </span>
        {isExtra && (
          <span className={s.deleteItem} onClick={() => handleDeleteService(id)}>
            Eliminar
          </span>
        )}
      </div>
      <div>Descripción: {description ?? 'No especificado'}</div>
      <DividerSection />

      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <AccessTimeIcon fontSize="small" />
        Duración: {duration ?? 'No especificada'} minutos
      </div>
    </div>
  )
}

export default CardSelectedService
